import { FC } from "react";

import { Box, Text, VStack } from "@/components/ui";

import RichText from "./RichText";

/* ── Types ─────────────────────────────────────── */

interface InsightCardProps {
  /** Body copy; `**text**` marks terms to highlight. */
  body: string;
  headline: string;
  /** Where the numbers come from. */
  sources: string[];
}

/* ── Component ─────────────────────────────────── */

/** Same dark "Key Insights" shell as the product's AI summaries. */
const InsightCard: FC<InsightCardProps> = ({ body, headline, sources }) => (
  <Box
    className="rounded-2xl p-6 lg:p-8"
    style={{ backgroundColor: "hsl(222, 24%, 12%)" }}
  >
    <VStack className="gap-3">
      <Text
        className="text-xs font-semibold tracking-widest uppercase"
        style={{ color: "rgba(255,255,255,0.4)", letterSpacing: 2 }}
      >
        Key insights
      </Text>
      <Text
        className="text-3xl leading-snug mt-2 [font-family:Newsreader,Georgia,serif]"
        style={{ color: "rgba(255,255,255,0.95)" }}
      >
        {headline}
      </Text>
      <RichText
        boldStyle={{ color: "rgba(255,255,255,0.98)" }}
        className="text-sm leading-[22px]"
        style={{ color: "rgba(255,255,255,0.75)" }}
        text={body}
      />
      <VStack className="gap-0.5 mt-2">
        {sources.map((source, i) => (
          <Text
            className="text-[11px] leading-4"
            key={i}
            style={{ color: "rgba(255,255,255,0.4)" }}
          >
            {i + 1}. {source}
          </Text>
        ))}
      </VStack>
    </VStack>
  </Box>
);

export default InsightCard;
